module.exports = __webpack_public_path__ + "img/person_search-24px.c5b087b2.svg";